export var Industry;
(function (Industry) {
    Industry["BEAUTY_AND_WELLNESS"] = "BEAUTY_AND_WELLNESS";
    Industry["CREATIVE"] = "CREATIVE";
    Industry["EDUCATION"] = "EDUCATION";
    Industry["FIELD_AND_CONSTRUCTION"] = "FIELD_AND_CONSTRUCTION";
    Industry["FITNESS"] = "FITNESS";
    Industry["HEALTH"] = "HEALTH";
    Industry["HOTELS"] = "HOTELS";
    Industry["NON_PROFIT_AND_COMMUNITIES"] = "NON_PROFIT_AND_COMMUNITIES";
    Industry["PHOTOGRAPHERS"] = "PHOTOGRAPHERS";
    Industry["EVENTS"] = "EVENTS";
    Industry["REAL_ESTATE"] = "REAL_ESTATE";
    Industry["RESTAURANTS"] = "RESTAURANTS";
    Industry["SCIENCE_AND_TECHNOLOGY"] = "SCIENCE_AND_TECHNOLOGY";
    Industry["TRAVEL_AND_TOURISM"] = "TRAVEL_AND_TOURISM";
})(Industry || (Industry = {}));
export var Style;
(function (Style) {
    Style["DARK"] = "DARK";
    Style["MINIMAL"] = "MINIMAL";
    Style["ILLUSTRATIVE"] = "ILLUSTRATIVE";
    Style["TYPOGRAPHY"] = "TYPOGRAPHY";
})(Style || (Style = {}));
export var SiteType;
(function (SiteType) {
    SiteType["ONLINE_STORE"] = "ONLINE_STORE";
    SiteType["BUSINESS_SITE"] = "BUSINESS_SITE";
    SiteType["PORTFOLIO_CV"] = "PORTFOLIO_CV";
    SiteType["LANDING_PAGE"] = "LANDING_PAGE";
    SiteType["BLOG"] = "BLOG";
    SiteType["SERVICES"] = "SERVICES";
})(SiteType || (SiteType = {}));
export var Status;
(function (Status) {
    Status["PENDING"] = "PENDING";
    Status["PUBLISHED"] = "PUBLISHED";
    Status["REJECTED"] = "REJECTED";
    Status["REMOVED"] = "REMOVED";
})(Status || (Status = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SortType;
(function (SortType) {
    SortType["COUNT"] = "COUNT";
    SortType["VALUE"] = "VALUE";
})(SortType || (SortType = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["DESC"] = "DESC";
    SortDirection["ASC"] = "ASC";
})(SortDirection || (SortDirection = {}));
export var ScalarType;
(function (ScalarType) {
    ScalarType["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
    ScalarType["COUNT_DISTINCT"] = "COUNT_DISTINCT";
    ScalarType["MIN"] = "MIN";
    ScalarType["MAX"] = "MAX";
    ScalarType["SUM"] = "SUM";
    ScalarType["AVG"] = "AVG";
})(ScalarType || (ScalarType = {}));
export var AggregationType;
(function (AggregationType) {
    AggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    AggregationType["VALUE"] = "VALUE";
    AggregationType["RANGE"] = "RANGE";
    AggregationType["SCALAR"] = "SCALAR";
})(AggregationType || (AggregationType = {}));
export var Mode;
(function (Mode) {
    /** any */
    Mode["OR"] = "OR";
    /** all */
    Mode["AND"] = "AND";
})(Mode || (Mode = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map